import { MARGIN_TRANSFER_SECTIONS } from './enums'

export const selectOptions = [
  {
    name: 'Isolated Margin',
    value: MARGIN_TRANSFER_SECTIONS.ISOLATED,
    allowedOptions: [
      MARGIN_TRANSFER_SECTIONS.CROSS,
      MARGIN_TRANSFER_SECTIONS.ISOLATED,
      MARGIN_TRANSFER_SECTIONS.FIAT_AND_SPOT,
    ],
  },
  {
    name: 'Cross Margin',
    value: MARGIN_TRANSFER_SECTIONS.CROSS,
    allowedOptions: [MARGIN_TRANSFER_SECTIONS.ISOLATED, MARGIN_TRANSFER_SECTIONS.FIAT_AND_SPOT],
  },
  {
    name: 'Funding',
    value: MARGIN_TRANSFER_SECTIONS.FUNDING,
    allowedOptions: [MARGIN_TRANSFER_SECTIONS.FIAT_AND_SPOT],
  },
  {
    name: 'Fiat and Spot',
    value: MARGIN_TRANSFER_SECTIONS.FIAT_AND_SPOT,
    allowedOptions: [
      MARGIN_TRANSFER_SECTIONS.CROSS,
      MARGIN_TRANSFER_SECTIONS.ISOLATED,
      MARGIN_TRANSFER_SECTIONS.FUNDING,
    ],
  },
]

export type MarginSelectOptionType = (typeof selectOptions)[number]
